module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/results-released.jpg?v=afa0f20a";